import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseValidationResult } from "@ha/ui/forms";
import { Observable } from "rxjs";

import { RecentTeamMemberSort, RecentTeamMembersResponse } from "../../shared/models/permit-person.model";
import { CountersignPermitCommand, CountersignPermitResponse, CreateCertificateAndPersonResponse, CreateCertificateCommand, CreatePermitTeamTextMemberCommand, CreatePermitTeamTextMemberResponse } from "../models/create-certificate-person.model";
import { AddStagedPersonsToPermitCommand, AddStagedPersonsToPermitResponse, FindCertifiedPersonQuery, FindCertifiedPersonResult, FireWatchersNotNeededCommand, RemovePersonFromPermitCommand, SearchPersonForPermitCommand, SearchPersonForPermitResponse, ToggleAllowSwitchingCommand } from "../models/permit-team-commands.model";
import { PermitTeam } from "../models/permit-team.model";
import { SignPermitWithSignatureCommand } from "../models/sign-permit-with-signature-command";

@Injectable({ providedIn: "root" })
export class PermitTeamService {
    constructor(private httpClient: HttpClient) {}

    public addStagedPersonsToPermit(
        command: AddStagedPersonsToPermitCommand,
    ): Observable<AddStagedPersonsToPermitResponse> {
        return this.httpClient.post<AddStagedPersonsToPermitResponse>(
            "/api/PermitPerson/AddStagedPersonsToPermit",
            command,
        );
    }

    public createPermitTeamTextMember(command: CreatePermitTeamTextMemberCommand): Observable<CreatePermitTeamTextMemberResponse> {
        return this.httpClient.post<CreatePermitTeamTextMemberResponse>("/api/PermitTeamTextMember/CreatePermitTeamTextMember", command);
    }

    public countersignaturePermit(command: CountersignPermitCommand): Observable<CountersignPermitResponse> {
        return this.httpClient.post<CountersignPermitResponse>("/api/PermitTeamTextMember/CountersignaturePermit", command);
    }

    public createCertificate(command: CreateCertificateCommand): Observable<CreateCertificateAndPersonResponse> {
        return this.httpClient.post<CreateCertificateAndPersonResponse>("/api/PermitPerson/CreateCertificate", command);
    }

    public findPerson(query: FindCertifiedPersonQuery): Observable<FindCertifiedPersonResult> {
        const options = {
            params: {
                query: query.query,
                isPremium: query.isPremium,
            },
        };

        return this.httpClient.get<FindCertifiedPersonResult>("/api/Certificate/SearchCertificate", options);
    }

    public findPersonBA(query: FindCertifiedPersonQuery): Observable<FindCertifiedPersonResult> {
        const options = {
            params: {
                query: query.query,
                isPremium: query.isPremium,
            },
        };

        return this.httpClient.get<FindCertifiedPersonResult>("/api/Certificate/SearchCertificateBA", options);
    }

    public getRecentTeamMembers(
        permitId: number,
        skip: number,
        take: number,
        includeColleagues: boolean,
        includeSharedFromPremium: boolean,
        sort: RecentTeamMemberSort,
        sortByDescending: boolean,
        query: string,
    ): Observable<RecentTeamMembersResponse> {
        const options = {
            params: {
                permitId,
                skip,
                take,
                includeColleagues,
                includeSharedFromPremium,
                sort,
                sortByDescending,
                query,
            },
        };

        return this.httpClient.get<RecentTeamMembersResponse>("/api/PermitPerson/GetRecentTeamMembers", options);
    }

    public searchPersonForPermit(query: SearchPersonForPermitCommand): Observable<SearchPersonForPermitResponse> {
        return this.httpClient.post<SearchPersonForPermitResponse>("/api/PermitPerson/SearchPersonForPermit", query);
    }

    public getTeam(permitId: number): Observable<PermitTeam> {
        const options = {
            params: {
                permitId: permitId,
            },
        };

        return this.httpClient.get<PermitTeam>("/api/PermitPerson/GetTeam", options);
    }

    public removePerson(command: RemovePersonFromPermitCommand) {
        return this.httpClient.delete<BaseValidationResult>("/api/PermitPerson/RemovePerson", { body: command });
    }

    public toggleAllowSwitching(command: ToggleAllowSwitchingCommand) {
        return this.httpClient.post<BaseValidationResult>("/api/PermitPerson/ToggleAllowSwitching", command);
    }

    public setFireWatchersNotNeeded(command: FireWatchersNotNeededCommand) {
        return this.httpClient.post<BaseValidationResult>("/api/PermitPerson/FireWatchersNotNeeded", command);
    }

    public signPermitWithSignature(command: SignPermitWithSignatureCommand) {
        return this.httpClient.post<BaseValidationResult>("/api/PermitPerson/SignPermitWithSignature", command);
    }
}
